import emailValidation from "@/lib/prismicio/prismic-email-validation.json";
export const useEmailValidation = () => emailValidation;
